import React from 'react';
import { useLocation } from 'react-router-dom';

import TicketsList from './TicketsList';
import TicketsMetrics from './TicketsMetrics';

function TicketPage() {
    const multidrawId = parseInt(new URLSearchParams(useLocation().search).get('multidraw_id')) || 0;

    return (
        <>
            <TicketsMetrics url="/crea/api/metrics" />
            <TicketsList multidrawId={multidrawId} />
        </>
    );
}

export default TicketPage;
